// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__34DtM","vLegacy":"SelectSecondary_vLegacy__1gzYR","error":"SelectSecondary_error__1_D1e","disabled":"SelectSecondary_disabled__3fZ4z"};